/** Shared chat styling for the SDK's shadow root and light DOM. */
import { OTOKOC_LAUNCHER_AVATAR_URL } from './config.js';
import { queryAllAcrossRoots } from './domUtils.js';

export const CHAT_APPEARANCE_STYLES = `
  .gengage-chat-conversation {
    background: #f4f2ed !important;
    color: #151c25;
    --gengage-primary-color: #0f2b5b;
  }
  .gengage-chat-root .gengage-chat-header {
    position: relative !important;
    background: #fcfbf9 !important;
    color: #151c25 !important;
    border-bottom: 0 !important;
    padding: 24px 20px 20px !important;
    gap: 12px !important;
    flex-shrink: 0;
  }
  .gengage-chat-header-left { gap: 12px !important; min-width: 0; position: relative; }
  .gengage-chat-header-left::after {
    content: ''; position: absolute; left: 36px; top: 35px;
    width: 11px; height: 11px; border: 2px solid #fcfbf9;
    border-radius: 50%; background: #45c65a;
  }
  .gengage-chat-header-info { min-width: 0; }
  .gengage-chat-header-title { font-size: 17px !important; font-weight: 600 !important; letter-spacing: 0; }
  [data-gengage-part="chat-header-powered-by"]:not(.otokoc-chat-branding),
  .gengage-chat-header-powered-by:not(.otokoc-chat-branding),
  .gengage-chat-powered-by:not(.otokoc-chat-branding) {
    display: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    overflow: hidden !important;
  }
  .otokoc-chat-branding { display: flex; align-items: center; gap: 4px; margin-top: 4px; font-size: 11px; line-height: 1.3; color: #7c8185; text-decoration: none; }
  .otokoc-chat-branding svg { width: 12px; height: 12px; }
  .gengage-chat-header-right { gap: 8px !important; flex-shrink: 0; }
  .gengage-chat-header-btn, .gengage-chat-close {
    width: 42px !important; height: 42px !important; min-width: 42px !important;
    border-radius: 50% !important; background: #f0efeb !important; color: #151c25 !important;
    border: 0 !important;
  }
  .gengage-chat-header-btn svg, .gengage-chat-close svg { width: 22px; height: 22px; stroke-width: 1.7; }
  .gengage-chat-conversation:not(:has(.gengage-chat-bubble--user)) [data-gengage-part="chat-header-new-chat"] { display: none !important; }
  .gengage-chat-messages {
    background: #f4f2ed !important; background-image: none !important;
    padding: 26px 18px !important; gap: 20px !important;
  }
  .gengage-chat-bubble--assistant, .gengage-chat-bubble--user {
    position: relative; max-width: calc(100% - 48px) !important;
    padding: 13px 15px !important; line-height: 1.5 !important; font-size: 15px !important;
    border: 1px solid #eae7e2 !important; border-radius: 17px !important;
    box-shadow: 0 2px 8px #302c2310 !important;
  }
  .gengage-chat-bubble--assistant {
    align-self: flex-start !important; margin-left: 46px !important; margin-right: auto !important;
    background: #fdfcfb !important; color: #151c25 !important; overflow: visible !important;
  }
  .gengage-chat-bubble--assistant::before,
  .gengage-chat-typing::before {
    content: ''; position: absolute; left: -47px; top: 10px; width: 36px; height: 36px;
    border-radius: 50%; background: #ebe8e1 url('${OTOKOC_LAUNCHER_AVATAR_URL}') center 38% / cover;
  }
  .gengage-chat-bubble--user {
    align-self: flex-end !important; margin-left: auto !important; margin-right: 0 !important;
    background: #e8eef7 !important; color: #173963 !important;
  }
  .gengage-chat-typing::before { top: calc(50% - 18px); }
  .gengage-chat-typing.gds-progress-loader {
    position: relative !important; overflow: visible !important;
    width: fit-content !important; min-width: 0 !important; min-height: 42px !important;
    padding: 14px 18px !important; margin-left: 46px; gap: 0 !important;
    background: #fdfcfb !important; border: 1px solid #eae7e2 !important;
    border-radius: 17px !important; box-shadow: 0 2px 8px #302c2310 !important;
  }
  /* Keep the status accessible while the visual indicator is dots only. */
  .gengage-chat-typing .gengage-chat-typing-text {
    position: absolute !important; width: 1px !important; height: 1px !important;
    padding: 0 !important; margin: -1px !important; overflow: hidden !important;
    clip-path: inset(50%) !important; white-space: nowrap !important; border: 0 !important;
  }
  .gengage-chat-typing .gds-progress-dot { background: #0f2b5b !important; }
  .gengage-chat-bubble-text p { margin: 0 !important; }
  .gengage-chat-bubble-text p + p { margin-top: 10px !important; }
  .gengage-chat-pills {
    background: #f4f2ed !important; padding: 12px 14px !important;
    border: 0 !important; flex-shrink: 0; max-height: 32vh; overflow-y: auto;
  }
  .gengage-chat-pills-viewport { width: 100%; min-width: 0; overflow: visible !important; mask-image: none !important; }
  .gengage-chat-pills-viewport::before, .gengage-chat-pills-viewport::after,
  .gengage-chat-pills-arrow { display: none !important; }
  .gengage-chat-pills-scroll {
    display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px !important; overflow: visible !important; padding: 0 !important;
  }
  .gengage-chat-pill {
    display: flex !important; align-items: center; gap: 9px !important;
    min-width: 0 !important; min-height: 60px; padding: 10px !important;
    border-radius: 15px !important; border: 1px solid #e8e5e0 !important;
    background: #fdfcfb !important; color: #151c25 !important;
    box-shadow: 0 2px 3px #302c2305 !important; white-space: normal !important;
    font-size: 13px !important; font-weight: 400 !important; text-align: left;
  }
  .gengage-chat-pill:hover { background: #ffffff !important; border-color: #9baecb !important; }
  .gengage-chat-root .gengage-chat-pill-text { white-space: normal !important; line-height: 1.35; flex: 1; font-size: 13px !important; font-weight: 400 !important; }
  .gengage-chat-pill::after {
    content: ''; width: 7px; height: 7px; border-top: 1.5px solid #989d9b;
    border-right: 1.5px solid #989d9b; transform: rotate(45deg); flex-shrink: 0; margin-right: 3px;
  }
  .gengage-chat-pill-icon {
    width: 34px !important; height: 34px !important; flex: 0 0 34px;
    display: grid !important; place-items: center; color: #0f2b5b;
    border: 1px solid #efede9; border-radius: 50%;
  }
  .gengage-chat-pill-icon svg { width: 23px !important; height: 23px !important; }
  .gengage-chat-input-area { background: #f4f2ed !important; padding: 10px 12px 0 !important; border: 0 !important; }
  .gengage-chat-input-pill {
    background: #fffefd !important; border: 1px solid #eeece8 !important;
    border-radius: 999px !important; min-height: 52px !important;
    padding: 5px 6px 5px 18px !important; gap: 8px !important; box-shadow: none !important;
  }
  .gengage-chat-input-pill:focus-within { border-color: #8fa3c2 !important; box-shadow: 0 0 0 3px #0f2b5b12 !important; }
  .gengage-chat-root .gengage-chat-input { min-height: 24px !important; padding: 6px 0 !important; font-size: 16px !important; line-height: 1.35 !important; color: #151c25 !important; background: transparent !important; }
  .gengage-chat-input::placeholder { color: #969b9d !important; }
  .gengage-chat-attach-wrap:empty { display: none !important; }
  .gengage-chat-send {
    width: 40px !important; height: 40px !important; min-width: 40px !important;
    border-radius: 50% !important; background: #0f2b5b !important; color: white !important;
    border: 1px solid #0b224a !important; box-shadow: none !important;
  }
  .gengage-chat-send:disabled { opacity: .65 !important; }
  .gengage-chat-send svg { width: 22px; height: 22px; }
  .gengage-chat-footer {
    background: #f4f2ed !important; color: #919797 !important; text-align: center;
    padding: 8px 24px max(14px, env(safe-area-inset-bottom)) !important;
    font-size: 10px !important; line-height: 1.5 !important; border: 0 !important;
  }
  .gengage-chat-pill:focus-visible, .gengage-chat-header button:focus-visible { outline: 2px solid #0f2b5b; outline-offset: 3px; }
  @media (min-width: 769px) {
    .gengage-chat-drawer { border-radius: 28px 0 0 28px !important; overflow: hidden; }
  }
  @media (max-width: 768px) {
    .gengage-chat-root .gengage-chat-header { padding: 32px 18px 20px !important; }
    .gengage-chat-drawer-handle {
      display: block !important; position: absolute !important; top: 10px !important;
      left: calc(50% - 22px) !important; width: 44px !important; height: 4px !important;
      background: #d0d1cf !important; border-radius: 99px;
    }
  }
  @media (max-width: 370px) {
    .gengage-chat-root .gengage-chat-header { padding-left: 12px !important; padding-right: 12px !important; gap: 6px !important; }
    .gengage-chat-header-title { font-size: 15px !important; }
    .gengage-chat-header-left { gap: 8px !important; }
    .gengage-chat-header-right { gap: 4px !important; }
    .gengage-chat-header-btn, .gengage-chat-close { width: 36px !important; min-width: 36px !important; height: 36px !important; }
    .gengage-chat-pill { gap: 6px !important; padding: 8px !important; font-size: 12px !important; }
    .gengage-chat-pill-icon { width: 28px !important; height: 28px !important; flex-basis: 28px; }
  }
  @media (max-height: 600px) {
    .gengage-chat-root .gengage-chat-header { padding-top: 18px !important; padding-bottom: 10px !important; }
    .gengage-chat-pills { max-height: 100px; }
    .gengage-chat-footer { padding-top: 6px !important; padding-bottom: max(8px, env(safe-area-inset-bottom)) !important; }
  }
`;

const ACTION_ICONS = {
  car: '<path d="m5 7 2-4h10l2 4M5 7h14l2 5v7H3v-7l2-5Zm-2 7h18M6 19v2m12-2v2"/><circle cx="7" cy="11" r="1"/><circle cx="17" cy="11" r="1"/>',
  calendar:
    '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4m10-4v4M3 10h18m-12 6 2 2 4-5"/>',
  service:
    '<path d="M14 6a5 5 0 0 0-6 6L2.5 17.5a2.8 2.8 0 0 0 4 4L12 16a5 5 0 0 0 6-6l-4 4-4-4 4-4Z"/>',
};

export function applyChatAppearance(): void {
  for (const info of queryAllAcrossRoots('[data-gengage-part="chat-header-info"]')) {
    for (const legacyBranding of info.querySelectorAll<HTMLElement>(
      '[data-gengage-part="chat-header-powered-by"]:not(.otokoc-chat-branding), .gengage-chat-header-powered-by:not(.otokoc-chat-branding), .gengage-chat-powered-by:not(.otokoc-chat-branding)'
    )) {
      legacyBranding.remove();
    }
    if (info.querySelector('.otokoc-chat-branding')) continue;
    const branding = document.createElement('a');
    branding.className = 'otokoc-chat-branding';
    branding.dataset.gengagePart = 'chat-header-powered-by';
    branding.href = 'https://gengage.ai/';
    branding.target = '_blank';
    branding.rel = 'noopener noreferrer';
    // Use the SDK's original Gengage mark alongside its attribution label.
    branding.innerHTML =
      '<svg viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M15 5.88941C12.2201 5.88941 9.72762 7.14107 8.05571 9.11059H0C2.77991 9.11059 5.27238 7.85893 6.94429 5.88941H15Z" fill="currentColor"/><path d="M9.10964 0C9.10964 2.24394 8.29524 4.30038 6.94429 5.88941C5.27238 7.85962 2.77922 9.11059 0 9.11059V5.88941C3.24802 5.88941 5.89036 3.2465 5.89036 0H9.10964Z" fill="currentColor" fill-opacity="0.68"/><path d="M15 5.88941V9.11059C11.752 9.11059 9.10964 11.7535 9.10964 15H5.89036C5.89036 12.7561 6.70476 10.6996 8.05571 9.11059C9.72762 7.14038 12.2208 5.88941 15 5.88941Z" fill="currentColor" fill-opacity="0.68"/></svg>Gengage';
    info.appendChild(branding);
  }
  for (const pill of queryAllAcrossRoots('.gengage-chat-pill')) {
    const label = pill.querySelector('.gengage-chat-pill-text')?.textContent ?? '';
    const kind = /servis/iu.test(label)
      ? 'service'
      : /test sürüşü/iu.test(label)
        ? 'calendar'
        : /Ford|SUV/iu.test(label)
          ? 'car'
          : null;
    if (!kind || pill.dataset.otokocIcon === kind) continue;
    const icon = pill.querySelector('.gengage-chat-pill-icon');
    if (!icon) continue;
    icon.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ACTION_ICONS[kind]}</svg>`;
    pill.dataset.otokocIcon = kind;
  }
}
